import { createStyles, makeStyles } from "@material-ui/core/styles";
import React from "react";

export interface OrdersInfoChannelProps {
  orderChannelImage: any;
}

const useStyles = makeStyles((theme: any) =>
  createStyles({
    imgStyle: {
      marginRight: "20px",
      width: "35px",
      height: "35px",
      [theme.breakpoints.down("sm")]: {
        width: "35px",
        height: "35px",
        marginRight: "0px",
      },
      [theme.breakpoints.down("xs")]: {
        width: "30px",
        height: "30px",
      },
    },
  }),
);

/**
 * OrdersInfoChannel Component
 *
 * This component is responsible for rendering the image associated with the order channel.
 * It receives the order channel image as a prop and displays it in a styled img tag.
 */
const OrdersInfoChannel: React.FunctionComponent<OrdersInfoChannelProps> = ({
  orderChannelImage,
}) => {
  const classes = useStyles();
  return (
    <>
      <img
        src={orderChannelImage}
        className={classes.imgStyle}
        alt="order channel image"
      />
    </>
  );
};

export default OrdersInfoChannel;
